import { schemaMixin } from '@witkac/jschema';

import AppTextarea from '@/components/form/textarea.vue';
import AppSelect from '@/components/form/select.vue';
import AppRadio from '@/components/form/radio.vue';
import AppPreviewValue from '@/components/form/preview-value.vue';
import AppPagination from '@/components/form/pagination.vue';
import AppInput from '@/components/form/input.vue';
import AppError from '@/components/form/error.vue';
import AppDatepicker from '@/components/form/datepicker.vue';
import AppCheckbox from '@/components/form/checkbox.vue';
import AppInputCol from '@/components/form/input-col.vue';
import AppTextareaCol from '@/components/form/textarea-col.vue';
import AppCheckboxCol from '@/components/form/checkbox-col.vue';
import AppDatepickerCol from '@/components/form/datepicker-col.vue';
import AppTreeStructurePicker from '@/components/form/tree-structure-picker.vue';
import AppAdvancedSelect from '@/components/form/advanced-select.vue';

export default {
  mixins: [schemaMixin],
  components: {
    AppTextarea,
    AppSelect,
    AppRadio,
    AppPreviewValue,
    AppPagination,
    AppInput,
    AppError,
    AppDatepicker,
    AppCheckbox,
    AppInputCol,
    AppTextareaCol,
    AppCheckboxCol,
    AppDatepickerCol,
    AppTreeStructurePicker,
    AppAdvancedSelect
  },
  data() {
    return {
      model: {}
    };
  }
};
